<template>
    <div class="table-responsive product-create">
        <table class="table table-bordered table-custom mb-0">
            <thead>
            <tr>
                <th style="width: 70px">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="checkAll" name="checkAll"
                               v-model="checkAll"
                               v-on:click="checkAllEvent($event)">
                        <label class="custom-control-label" for="checkAll">All</label>
                    </div>
                </th>
                <th>Item #</th>
                <th style="width: 40%;">Item name</th>
                <th>Quantity</th>
                <th>
                    <select class="form-control" v-model="qty_unit_id">
                        <option value="">Select UOM</option>
                        <option v-for="(qtyUnit, unitIndex) in quantityUnits" :value="qtyUnit.id">
                            {{ qtyUnit.name }}
                        </option>
                    </select>
                </th>
                <th>Selling price</th>
                <th>SO</th>
                <!--<th>Purchase price</th>-->
                <th>Vendor</th>
            </tr>
            </thead>
            <SelectedProducts :key="'test_'+10" :products="products"
                              :selected-products="selectedProducts"
                              :is-quote="false"
                              :quantity-units="quantityUnits"
                              :bus="bus"
                              :product-data="productData"
                              @removeProductCheckbox="removeProductCheckbox"
                              @watchChangedProducts="updateProducts"></SelectedProducts>
            <!--<tbody name="product-table" is="transition-group">-->
            <tbody name="product-table" :key="'tbody_2'">
            <template v-if="productData">

                <template v-for="(product, index) in productData.products.data">
                    <template v-if="products.filter((y) => y.product_id == product.id).length == 0">
                        <tr :key="'unsel_'+products.length + index" :id="'unsel_'+products.length + index">
                            <td>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input"
                                           :value="product.id"
                                           :id="'id_' +index"
                                           name="uns_prod_ids[]"
                                           :checked="false"
                                           :disabled="selectedProducts.includes(product.id)"
                                           @click="selectProductCheckbox(product, $event)">
                                    <label class="custom-control-label" :for="'id_' +index"></label>
                                </div>
                            </td>
                            <td>
                                <router-link :to="{ name: 'productsDetails', params: { id: product.id }}" target="_blank">{{ product.product_num }}</router-link>
                            </td>
                            <td>
                                <strong>{{ product.product_name }}</strong>
                                <p class="truncated-dotted" v-html="product.product_desc"></p>
                            </td>
                            <td>
                                {{ product.qty }}
                            </td>
                            <td>
                                <template v-if="product.qty_unit_id != ''">
                                    {{ getQuantityUnitName(product.qty_unit_id) }}
                                </template>
                                <template v-else>
                                     {{ getQuantityUnitName(product.unit_id) }}
                                </template>
                                
                            </td>
                            <td>
                                ${{ product.price }}
                            </td>
                            <td></td>
                            <!--<td>
                                ${{ product.vendor_cost }}
                            </td>-->
                            <td>
                                <template v-if="getVendorId(product)">
                                    <router-link
                                        :to="{name: 'vendorDetails', params: {id: getVendorId(product)}}"
                                        title="Details vendor" target="_blank">
                                        {{ getVendorName(product) }}</router-link>
                                </template>
                            </td>
                        </tr>
                    </template>

                </template>
            </template>

            </tbody>
        </table>
    </div>
</template>

<script>
import axios from "axios";
import {mapActions, mapGetters, mapState} from "vuex";
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import SelectedProducts from "./SelectedProducts";

export default {
    name: "Products",
    components: {
        ValidationProvider, ValidationObserver, SelectedProducts
    },
    props: ['selectedProducts', 'search_filter', 'bus', 'quantityUnits', 'exclude_products', 'products'],
    created() {
        if (localStorage.getItem('token')) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.getProducts();
    },
    mounted() {
        if (this.search_filter) {
            this.filterForm.search_filter = this.search_filter;
        }
        this.bus.$on('getProducts', this.getProducts);
        this.bus.$on('addNewProduct', (product) => {
           if(this.productData.products.data) {
               this.productData.products.data.push(product);
           }
        });

        window.onscroll = () => {
            let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
            if (bottomOfWindow && this.loadedScrollAllPage == 0) {
                this.current_page += 1;
            }
        }
    },
    data() {
        return {
            productData: {
                products: {
                    data: []
                },
                config: null,
            },
            current_page: 1,
            loadedScrollAllPage: 0,
            per_page: 15,
            total: 0,
            filterForm: {
                search_filter: null,
                status_filter: '1'
            },
            checkAll: false,
            editorConfig: {},
            editorConfigMin: {
                toolbar: []
            },
            qty_unit_id: null
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
            'setProductsLoading'
        ]),
        getQuantityUnitName(id) {
            if (id != null) {
                let unit = this.quantityUnits.find((x) => x.id == id);
                if (unit) {
                    return unit.name;
                }
            }
            return '';
        },
        getVendorName(product) {
            let vendor = this.getVendorFromProduct(product);
            if (vendor) {
                return vendor.company_name;
            }
            return null;
        },
        getVendorId(product) {
            let vendor = this.getVendorFromProduct(product);
            if (vendor) {
                return vendor.id;
            }
            return null;
        },
        getVendorFromProduct(product) {
            if (product.vendor) {
                return product.vendor;
            } else if (product.quotation_products) {
                let vendor = null;
                product.quotation_products.forEach((qp) => {
                    if (qp.quotation_prices && vendor == null) {
                        qp.quotation_prices.forEach((qpp) => {
                            if (qpp.vendor && vendor == null) {
                                vendor = _.cloneDeep(qpp.vendor);
                            }
                        })
                    }
                });
                return vendor;
            }
            return null;
        },
        checkAllEvent(event) {
            this.productData.products.data.forEach((x) => {
                this.selectProduct(x, event.target.checked);
            });
        },
        selectProductCheckbox(c, event) {
            //console.log('selectProductCheckbox', c.id)
            if(c.qty_unit_id == ''){
                c.qty_unit_id = c.unit_id
            }
            this.$emit('selectProduct', {c: _.cloneDeep(c), checked: event.target.checked});
        },
        deSelectProductCheckbox(c) {
            let product = this.productData.products.data.find((x) => x.id = c.product_id);
            setTimeout(() => {
                this.$emit('selectProduct', {c: product, checked: false});
            }, 300);
        },
        selectProduct(c, checked) {
            if (checked === null) {
                checked = !this.selectedProducts.includes(c.id);
            }
            this.$emit('selectProduct', {c: c, checked: checked});
        },
        removeProductCheckbox(event) {
            if(event.c.product_id != null && event.c.id == null) {
                event.c.id = event.c.product_id;
            }
            //console.log('removeProductCheckbox', event.c.id)
            this.$emit('selectProduct', event);
        },
        getProducts() {
            let self = this;
            this.setProductsLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('so.products.search', {
                page: this.current_page,
                per_page: this.per_page,
                exclude_products: this.exclude_products,
                search_filter: this.filterForm.search_filter,
                status_filter: this.filterForm.status_filter
            }), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        /*data.data.products.data.forEach((x) => {
                            x.price = "$" + this.strAmountToNumber(x.price);
                            // x.cost = "$" + this.strAmountToNumber(x.cost);
                        });*/

                        data.data.products.data.forEach((x, index) => {
                            if(x.order_products && x.order_products.length > 0) {
                                let orderProducts = x.order_products.filter((prod) => prod.order).sort( ( a, b) => {
                                    return new Date(b.order.updated_at) - new Date(a.order.updated_at);
                                });
                                if(orderProducts.length) {
                                    x.latest_order = {
                                        id: orderProducts[0].order.id,
                                        order_number: orderProducts[0].order.order_number,
                                        updated_at: orderProducts[0].order.updated_at
                                    };

                                    if(orderProducts[0].price) {
                                        x.price = orderProducts[0].price;
                                    }
                                }
                            }
                            if(!x.price) {
                                x.price = x.selling;
                            }
                            if(x.vendor_cost == null) {
                                x.vendor_cost = 0.00;
                                if(x.quotation_products && x.quotation_products.length){
                                    let quotation_products = x.quotation_products.filter((qp) => qp.quotation_price_detail && qp.quotation_price_detail.length > 0);

                                    if(quotation_products.length) {
                                        x.vendor_cost = parseFloat(quotation_products[0].quotation_price_detail[0].vendor_cost);
                                    }
                                }
                            }
                            let selectedProduct = null;
                            if (this.products != null && this.products.length > 0 &&
                                this.products.filter((xyz) => xyz.product_id == x.id).length > 0) {
                                selectedProduct = this.products.find((xyz) => xyz.product_id == x.id);
                            }
                            // console.log('selectedProduct', selectedProduct);
                            if(selectedProduct) {
                                x.product_name = selectedProduct.product_name;
                                x.product_desc = selectedProduct.product_desc;
                                x.qty = selectedProduct.qty;
                                x.qty_unit_id = selectedProduct.qty_unit_id;
                                x.price = selectedProduct.price;
                                x.cost = selectedProduct.cost;
                            }
                        });

                        if(this.current_page > 1) {
                            if( data.data.products.data.length ==0) {
                                this.loadedScrollAllPage = 1;
                            }
                            this.productData.products.data = this.productData.products.data.concat(data.data.products.data);
                        } else {
                            if(this.productData.products.data.length > 0 && this.products.length > 0) {
                                this.productData.products.data =
                                    this.productData.products.data.filter((prod) => this.products.filter((sprod) => sprod.product_id == prod.id).length > 0)

                                this.productData.products.data =
                                    this.productData.products.data.concat(data.data.products.data.filter((prod) => this.products.filter((sprod) => sprod.product_id == prod.id).length == 0));
                            } else {
                                this.productData = data.data;
                            }
                        }
                        // this.current_page = data.data.products.current_page;
                        this.per_page = data.data.products.per_page;
                        this.total = data.data.products.total;

                        /*this.productData.products.data.forEach((x, index) => {
                            let selectedProduct = null;
                            if (this.products != null && this.products.length > 0 &&
                                this.products.filter((xyz) => xyz.product_id == x.id).length > 0) {
                                selectedProduct = this.products.find((xyz) => xyz.product_id == x.id);
                            }
                            // console.log('selectedProduct', selectedProduct);
                            if(selectedProduct) {
                                x.product_name = selectedProduct.product_name;
                                x.product_desc = selectedProduct.product_desc;
                                x.qty = selectedProduct.qty;
                                x.qty_unit_id = selectedProduct.qty_unit_id;
                                x.price = selectedProduct.price;
                                x.cost = selectedProduct.cost;
                            }
                        });*/

                        /*if (this.checkAll == true) {
                            this.productData.products.data.forEach((x) => {
                                //this.selectProduct(x, true);
                            });
                        }*/
                        if (this.selectedProducts != null && this.selectedProducts.length > 0 && this.productData.products.data != null) {
                            /*this.selectedProducts.foreach((id) => {
                                if(this.productData.products.data.filter((x) => x.id == id).length == 0) {
                                    this.selectProduct(x, false);
                                }
                            });*/
                            this.productData.products.data.sort((a, b) => {
                                if(this.selectedProducts.includes(a.id)) {
                                    return -1;
                                } else if(!this.selectedProducts.includes(a.id)) {
                                    return 1;
                                } else {
                                    return 0;
                                }

                            });
                        }

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setProductsLoading(false);

                });
        },
        getSLNo(index) {
            return Number(this.productData.config['start_from']) + index;
        },
        updateProducts(products) {
            //let updatedProducts = products.filter((x) => this.selectedProducts.filter((y) => y == x.id).length > 0);
            //this.$emit('watchChangedProducts', updatedProducts);
            this.$emit('watchChangedProducts', products);
        },
    },
    watch: {
        /*"productData.products.data": {
            handler: function (after, before) {
                after.forEach((x, index) => {
                    this.productData.products.data[index].unit_price = this.strAmountToNumber(x.price);
                    let sum = this.strAmountToNumber(x.price) * x.qty;
                    if (!isNaN(sum)) {
                        this.productData.products.data[index].cost = sum;
                        after[index].cost = sum;
                    }

                });
                this.updateProducts(after);
            },
            deep: true,
        },*/
        qty_unit_id: {
            handler: function (value) {
                if (value !== null && value !== '') {
                    this.products.forEach((product) => {
                        if(!product.quote_product_id) {
                            product.qty_unit_id = value;
                        }
                    });
                }
            }
        },
        current_page: {
            handler: function (value) {
                if (value != 1) {
                    this.getProducts();
                }
            }
        },
        search_filter: {
            handler: function (value) {
                this.filterForm.search_filter = value;
            }
        },
        selectedProducts: {
            handler: function (value, oldValue) {
                //console.log(value, oldValue)
                if (value != null && value.length > 0 && this.productData.products.data != null) {
                    this.productData.products.data.sort((a, b) => {
                       if(value.includes(a.id)) {
                           return -1;
                       } else if(!value.includes(a.id)) {
                           return 1;
                       } else {
                           return 0;
                       }
                    });
                }
                if (value != null && this.productData.products.data != null &&
                    this.productData.products.data.filter((x) => value.includes(x.id)).length == this.productData.products.data.length) {
                    this.checkAll = true;
                } else {
                    this.checkAll = false;
                }
            }
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
        ])
    }
}
</script>

<style scoped>
.error {
    color: red;
}
.product-list-item {
    transition: all 1s;
}
.product-list-enter,
.product-list-leave-to {
    max-height: 0px;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    overflow: hidden;
}
.product-list-enter-to,
.product-list-leave {
    max-height: 80px;
}

.product-table-item {
    transition: all 1s;
}
.product-table-item > * {
    transition: all 1s;
    overflow: hidden;
}
.product-table-enter,
.product-table-leave-to {
    line-height: 0;
}
.product-table-enter > *,
.product-table-leave-to > * {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
}
.product-table-enter-to,
.product-table-leave {
    line-height: 1.5;
}
</style>
